<template>
  <the-content>
    <div class="heading">
      <h1 class="heading-title">Клиенты</h1>
      <div class="heading-buttons">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn :to="{name: 'clients.add'}"
                   color="blue"
                   dark
                   :small="$vuetify.breakpoint.mdAndDown"
                   :fab="$vuetify.breakpoint.mdAndDown"
                   v-on="on"
            >
              <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-account-plus</v-icon>
              <span class="d-none d-lg-block">Новый клиент</span>
            </v-btn>
          </template>
          <span>Добавить нового клиента</span>
        </v-tooltip>
      </div>
    </div>

    <v-card class="clients-table">
      <v-card-title class="pa-0">
        <div class="clients-filter pa-4">
          <v-select
            v-model="selectedFilters"
            :items="filters"
            item-text="name"
            item-value="value"
            outlined
            dense
            chips
            deletable-chips
            small-chips
            multiple
            placeholder="Фильтр"
            clearable
            hide-details
          />
        </div>
        <v-divider></v-divider>
        <div class="clients-search pa-4">
          <v-text-field
            v-model="search"
            outlined
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            clearable
            dense
          />
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="filteredClients"
        :search="search"
        :items-per-page="15"
        :page.sync="page"
        :footer-props="footerProps"
        :loading="$constants.RESOURCE_STATUS_LOADING === clientsStatus"
      >
        <template v-slot:item.photo="{item}">
          <div
            v-if="item.photo"
            class="td-photo"
            :style="{backgroundImage: `url(' ${item.photo.url} ')`}"></div>
          <div
            v-else
            class="td-photo"
            :style="{backgroundImage: `url(' ${require('../assets/photo-placeholder.png')} ')`,opacity: 0.5}"></div>
        </template>

        <template v-slot:item.name="{item}">
          <div class="td-name" v-html="highlight(search, item.name)"></div>
          <v-chip v-if="isTodayBDay(item)" x-small color="green" text-color="white">
            День рождения
          </v-chip>

          <v-tooltip v-if="isLostClient(item)" bottom>
            <template v-slot:activator="{ on }">
              <v-chip x-small color="warning" v-on="on">
                Потерянный клиент
              </v-chip>
            </template>
            <span>Неактивен с {{$dayjs.unix(item.active_until).format('DD MMMM YYYY')}}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.phone="{item}">
          <div class="td-phone" v-html="highlight(search, formatPhone(item.phone), true)"></div>
          <v-chip v-if="item.viber_id" x-small color="#8f5db7" text-color="white" class="mr-1">Viber</v-chip>
          <v-chip v-if="item.telegram_id" x-small color="#36ade1" text-color="white" class="mr-1">Telegram
          </v-chip>
        </template>

        <template v-slot:item.active_cards="{item}">
          <template v-for="card in item.active_cards">
            <div v-if="'active' === card.status" :key="card.id" class="td-card">
              <div class="td-card__info">
                <div>{{getCardName(card)}}</div>
                <div><b>Посещений: </b>{{card.visits_count}} из {{card.visits_limit || 'безлимит'}} (до
                  {{$dayjs(card.end_at).format('DD MMM YYYY')}})
                </div>
              </div>
              <div class="td-card__actions">
                <div class="td-card__actions-item"
                     v-if="!card.visits_limit || card.visits_count < card.visits_limit">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn dark
                             depressed
                             color="green"
                             :x-small="$vuetify.breakpoint.smAndUp"
                             :fab="$vuetify.breakpoint.smAndUp"
                             :small="$vuetify.breakpoint.xsOnly"
                             :block="$vuetify.breakpoint.xsOnly"
                             @click.prevent="trackVisit(card)"
                             v-on="on"
                      >
                        <v-icon :left="$vuetify.breakpoint.xsOnly">mdi-check</v-icon>
                        <span v-if="$vuetify.breakpoint.xsOnly">Отметить</span>
                      </v-btn>
                    </template>
                    <span>Отметить посещение</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </template>
        </template>

        <template v-slot:item.action="{item}">
          <div class="td-actions">
            <div class="td-actions__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on:tooltip }">
                  <v-btn
                    color="green"
                    dark
                    depressed
                    :x-small="$vuetify.breakpoint.smAndUp"
                    :fab="$vuetify.breakpoint.smAndUp"
                    :small="$vuetify.breakpoint.xsOnly"
                    :block="$vuetify.breakpoint.xsOnly"
                    v-on="{...tooltip}"
                    @click.prevent="singleVisitDialogClientId=item.id"
                  >
                    <v-icon :left="$vuetify.breakpoint.xsOnly">mdi-plus-one</v-icon>
                    <span v-if="$vuetify.breakpoint.xsOnly">Разовое посещение</span>
                  </v-btn>
                </template>
                <span>Отметить разовое посещение</span>
              </v-tooltip>
            </div>
            <div class="td-actions__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn :to="{name: 'clients.show', params: {clientId: item.id}}"
                         color="primary"
                         depressed
                         :x-small="$vuetify.breakpoint.smAndUp"
                         :fab="$vuetify.breakpoint.smAndUp"
                         :small="$vuetify.breakpoint.xsOnly"
                         :block="$vuetify.breakpoint.xsOnly"
                         v-on="on"
                  >
                    <v-icon :left="$vuetify.breakpoint.xsOnly">mdi-eye</v-icon>
                    <span v-if="$vuetify.breakpoint.xsOnly">Открыть</span>
                  </v-btn>
                </template>
                <span>Открыть карточку клиента</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <single-visit-dialog class="mr-1" v-model="singleVisitDialogClientId"/>
    <card-expired-dialog v-model="showCardExpiredDialog"/>
  </the-content>
</template>

<script>
  import { parsePhoneNumberFromString } from 'libphonenumber-js';
  import dayjs from 'dayjs';
  import visitApi from '../api/visit.api';
  import lostClientMixin from '../mixins/lostClientMixin';
  import { mapState } from 'vuex';
  import CardExpiredDialog from '../components/CardExpiredDialog';
  import SingleVisitDialog from '../components/SingleVisitDialog';
  import cardExpiredNotificationMixin from '../mixins/cardExpiredNotificationMixin';

  export default {
    name      : 'ClientsPage',
    components: { SingleVisitDialog, CardExpiredDialog },
    mixins    : [lostClientMixin, cardExpiredNotificationMixin],
    data() {
      return {
        singleVisitDialogClientId: null,

        headers        : [
          { text: 'Фото', value: 'photo', class: 'th-photo', sortable: false, filterable: false },
          { text: 'Имя', value: 'name', class: 'th-name' },
          { text: 'Телефон', value: 'phone', class: 'th-phone' },
          {
            text      : 'Активный абонемент',
            value     : 'active_cards',
            class     : 'th-card',
            sortable  : false,
            filterable: false
          },
          { text: '', value: 'action', class: 'th-actions', sortable: false, filterable: false },
        ],
        page           : 1,
        footerProps    : {
          itemsPerPageOptions: [15, 30, 45, -1],
          showCurrentPage    : true,
          itemsPerPageText   : 'Клиентов на странице',
        },
        search         : '',
        filters        : [
          {
            name : 'Сегодня День Рождения',
            value: 'bdayToday'
          },
          {
            name : 'Viber',
            value: 'viber'
          },
          {
            name : 'Telegram',
            value: 'telegram'
          },
          {
            name : 'Потерянный клиент',
            value: 'lost'
          },
          {
            name : 'Мужчина',
            value: this.$constants.GENDER_MALE
          },
          {
            name : 'Женщина',
            value: this.$constants.GENDER_FEMALE
          }
        ],
        selectedFilters: [],
      };
    },
    computed  : {
      ...mapState({
        cardTypes    : state => state['card-types'].items,
        clients      : state => state['clients'].items,
        clientsStatus: state => state['clients'].status,
      }),
      filteredClients() {
        let clients = this.clients;

        // Filter By BDay
        if (this.selectedFilters.includes('bdayToday')) {
          clients = clients.filter(client => this.isTodayBDay(client));
        }

        if (this.selectedFilters.includes('viber')) {
          clients = clients.filter(client => client.viber_id);
        }

        if (this.selectedFilters.includes('telegram')) {
          clients = clients.filter(client => client.telegram_id);
        }

        if (this.selectedFilters.includes('lost')) {
          clients = clients.filter(client => this.isLostClient(client));
        }

        if (this.selectedFilters.includes(this.$constants.GENDER_MALE)) {
          clients = clients.filter(client => client.gender === this.$constants.GENDER_MALE);
        }

        if (this.selectedFilters.includes(this.$constants.GENDER_FEMALE)) {
          clients = clients.filter(client => client.gender === this.$constants.GENDER_FEMALE);
        }

        return clients;
      },
    },
    methods   : {
      isTodayBDay(client) {
        const today = dayjs().startOf('day');
        const bday  = dayjs(client.bday);
        return today.date() === bday.date() && today.month() === bday.month();
      },
      getCardName(card) {
        const cardType = this.cardTypes.find(cardType => cardType.id === card.card_type_id);
        return cardType ? cardType.name : null;
      },
      formatPhone(phone) {
        const phoneNumber = parsePhoneNumberFromString(phone);
        return phoneNumber ? phoneNumber.formatInternational() : '';
      },
      async trackVisit(card) {
        const confirmed = await this.$confirm('Вы уверены что хотите отметить посещение?');

        if (false === confirmed) {
          return;
        }

        visitApi.create({ card_id: card.id }).then(({ data }) => {
          this.$store.commit('clients/UPDATE_CARD', data.data);
          this.$_notifyCartExpired(data.data);
        }).catch(() => {
          this.$toast.error('Произошла ошибка во время отметки посещения');
        });
      },
      highlight(query, content, isPhone = false) {
        if (!query) {
          return content;
        }

        let regExp = query;

        if (true === isPhone) {
          let formatedQuery = '';
          for (let i = 0; i < query.length; i++) {
            formatedQuery += query.charAt(i) + '\\s?';
          }
          regExp = formatedQuery;
        }

        return content.replace(new RegExp(regExp, 'gi'), match => {
          return '<span class="v-data-table-item__mask">' + match + '</span>';
        });
      },
    }
  };
</script>

<style lang="scss">

  .clients-table {

    .v-data-table-item__mask {
      background: #82b1ffd6;
    }

    .clients-filter {
      flex: 0 0 50%;
      max-width: 50%;

      + .v-divider {
        display: none;
        flex: 0 0 100%;
        max-width: 100%;
      }

      .viewport-xs & {
        flex: 0 0 100%;
        max-width: 100%;

        + .v-divider {
          display: block;
        }
      }
    }


    .clients-search {
      flex: 0 0 50%;
      max-width: 50%;

      .viewport-xs & {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }


    .v-data-table tr {

      .viewport-xs & {

        &:hover:not(.v-data-table__expanded__content) {
          background-color: #fff;
        }
      }
    }

    .v-data-table td,
    .v-data-table th {
      #app & {
        padding-top: 10px;
        padding-bottom: 10px;
        height: auto;
      }
    }

    .v-data-table__mobile-row {
      #app & {
        &:first-child {
          padding-top: 16px;
        }

        &:last-child {
          padding-bottom: 16px;
        }
      }

      .viewport-xs & {
        display: block;
      }
    }

    .v-data-table__mobile-row__wrapper {
      display: block;
    }

    .v-data-table__mobile-row__cell {
      #app & {
        text-align: left;
      }
    }


    .v-data-footer {

      .viewport-xs & {
        justify-content: center;
        padding: 0;

        .v-data-footer__select {
          flex: 0 0 100%;
          max-width: 100%;
          margin: 0;
          justify-content: center;
          border-bottom: 1px solid #ccc;
          background-color: #f1f1f1;
        }

        .v-data-footer__pagination {
          margin-top: 20px;
          margin-bottom: 20px;
        }
      }
    }


    // th
    //
    .th-photo {
      width: 96px;
    }

    .th-name {

    }

    .th-phone {

    }

    .th-card {

    }

    .th-actions {
      width: 112px;
    }

    .th-recipients {
      width: 50%;
    }

    .th-message {
      width: 50%;
    }

    .th-date {
      width: 180px;
    }

    .th-typeCard {

    }


    // td
    //
    .td-photo {
      width: 60px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      border-radius: 4px;
      background-color: #E1F5FE;

      .viewport-xs & {
        width: 100px;
      }

      &:before {
        content: '';
        display: block;
        padding-bottom: 100%;
      }
    }

    .td-name {

    }

    .td-phone {
      white-space: nowrap;
    }

    .td-card {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #81D4FA;
      border-radius: 4px;
      padding: 8px;
      background-color: rgba(#E1F5FE, 0.5);
      color: #1976D2;
      font-size: 12px;
      max-width: 420px;
      min-width: 220px;

      .viewport-xs & {
        display: block;
        max-width: none;
      }

      + .td-card {
        margin-top: 8px;
      }

      .td-card__info {
        padding: 0 8px 0 0;

        .viewport-xs & {
          padding: 0 0 4px;
        }
      }

      .td-card__actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
        margin-left: -4px;
        margin-right: -4px;
      }

      .td-card__actions-item {
        padding: 4px;
        min-width: 40px;

        .viewport-xs & {
          flex: 1;
        }
      }
    }

    .td-actions {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: center;
      margin-left: -4px;
      margin-right: -4px;

      .td-actions__item {
        padding: 4px;

        .viewport-xs & {
          flex: 1;
        }
      }
    }

    .td-recipients {
      position: relative;
      height: 22px;

      .td-recipients__text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .td-message {
      position: relative;
      height: 22px;
      color: #607D8B;

      .td-message__text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .td-date {
      white-space: nowrap;
    }

    .td-cardType {
      display: flex;

      .box-color {
        width: 20px;
        height: 20px;
        min-width: 20px;
        border-radius: 2px;
        margin-right: 10px;
      }
    }
  }
</style>
